import { useState, useEffect } from 'react';
import { fetchRevenueSummaryByQueryString } from '../api/revenueSummary';

export function useRevenueSummary(queryString = '', { enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    const controller = new AbortController();

    async function load() {
      setLoading(true);
      setError(null);

      try {
        const result = await fetchRevenueSummaryByQueryString(queryString, {
          signal: controller.signal,
          timeout: 180000,
        });
        if (!cancelled) {
          setData(result.data);
          setDataSource(result.dataSource);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          const msg = err.name === 'AbortError' ? 'Request timed out' : (err.message || 'Failed to load revenue data');
          setError(msg);
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [queryString, enabled]);

  return { data, dataSource, loading, error };
}